import React from 'react';
import 'twin.macro';
import {
  FacebookEmbed,
  InstagramEmbed,
  KijkEmbed,
  TikTokEmbed,
  TwitchEmbed,
  TwitterEmbed,
  YoutubeEmbed,
} from './';

export const RatioIframe = (props) => (
  <iframe frameBorder='0' allowFullScreen={true} tw='absolute h-full w-full inset-0' {...props} />
);

export const EmbedMedia = ({ uri }) => {
  const [type, id] = uri.split(':');
  const [username, embedId] = id.includes('/') ? id.split('/') : ['', ''];

  return (
    <>
      {type === 'facebook' && <FacebookEmbed username={username} id={embedId} />}
      {type === 'instagram' && <InstagramEmbed id={id} />}
      {type === 'kijk.nl' && <KijkEmbed id={id} />}
      {type === 'tiktok' && <TikTokEmbed username={username} id={embedId} />}
      {type === 'twitch' && <TwitchEmbed id={id} />}
      {type === 'twitter' && <TwitterEmbed id={id} />}
      {type === 'youtube' && <YoutubeEmbed id={id} />}
    </>
  );
};
